<template>
    <div class="table-responsive wgxx">
        <div>
            <Table :show-header="false" :columns="colums" :data="list" :border="true" :loading="loading"></Table>
        </div>
        <div class="pagination">
            <Page :page-size="LIST_COUNT" :current="page" :total="total" @on-change="changePage" show-total>

            </Page>
        </div>
    </div>
</template>
<script>
    import { getType, pageList } from "api/tripNotify";
    const LIST_COUNT = 20;
    export default {
        data() {
            return {
                needHandle: false,
                parentMsgType: 4,
                condition: 0,
                colums: [
                    {
                        key: "msgDesc"
                    },
                    {
                        key: "content"
                    }
                ],
                list: [],
                page: 1,
                total: 0,
                loading: true,
                LIST_COUNT
            };
        },
        async created() {
            this.updateList();
        },
        methods: {
            updateList: async function() {
                try {
                    const typeRes = await getType();
                    const typeList = typeRes.data;
                    for (let type of typeList) {
                        if (type.parentMsgType === this.parentMsgType) {
                            this.needHandle = type.needHandle;
                            break;
                        }
                    }
                    const listRes = await pageList({
                        msgTypes: ["29", "30", "31", "32"].join(","),
                        needHandle: this.needHandle,
                        condition: this.condition,
                        page: this.page,
                        count: LIST_COUNT
                    });
                    this.total = listRes.paging.total;
                    this.list = listRes.data;
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e);
                }
            },
            changePage: function(page) {
                this.page = page;
                this.updateList();
            }
        }
    };
</script>
<style scoped>
.table-responsive {
  margin: 20px;
}
.pagination {
  width: 100%;
  text-align: right;
  padding: 20px;
  margin: 0;
}
.wgxx strong {
  font-weight: normal;
}
.wgxx .tbo-table-cell span {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// vendorsViolationVerify.vue?4674057e